const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

const isSameDay = (a, b) => a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate()

const LOCALE = 'en-US'
const ET_TIMEZONE = 'America/New_York'

const getETOffset = () => {
  const now = new Date()
  const nyStr = new Intl.DateTimeFormat('sv', {
    timeZone: ET_TIMEZONE,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  }).format(now)
  const offsetHrs = Math.abs(Math.round(
    (new Date(`${nyStr.replace(' ', 'T')}Z`).getTime() - now.getTime()) / 3600000
  ))
  return `-${String(offsetHrs).padStart(2, '0')}:00`
}

const isPastCutoff = (deliveryDate, cutoffTime) => {
  if (!deliveryDate || !cutoffTime) return false
  const [hours, minutes] = cutoffTime.substring(0, 5).split(':').map(Number)
  const now = new Date()
  const nowET = new Date(now.toLocaleString(LOCALE, { timeZone: ET_TIMEZONE }))
  const deliveryCutoff = `${deliveryDate.split('T')[0]}T${cutoffTime}${getETOffset()}`

  const estToLocalOffset = Number(now) - Number(nowET)
  const delivery = new Date(deliveryCutoff)
  const cutoffET = new Date(nowET)
  cutoffET.setFullYear(delivery.getFullYear(), delivery.getMonth(), delivery.getDate())
  cutoffET.setHours(hours, minutes, 0, 0)
  const cutoffLocal = new Date(Number(cutoffET) + estToLocalOffset)

  return now >= cutoffLocal
}

export const dateFormatter = (date, trim = false) => {
  try {
    const dateInstance = new Date(date)
    let EEEE = days[dateInstance.getDay()]
    if (trim) EEEE = EEEE.substring(0, 3)
    const dd = dateInstance.getDate()
    const MMM = months[dateInstance.getMonth()]
    return `${EEEE}, ${MMM} ${dd}`
  } catch (err) {
    console.log(err)
    return ''
  }
}

export const fullDateFormatterUTC = (date, trim = false) => {
  try {
    const dateInstance = new Date(date)
    let EEEE = days[dateInstance.getUTCDay()]
    if (trim) EEEE = EEEE.substring(0, 3)
    const dd = dateInstance.getUTCDate()
    const MMM = months[dateInstance.getUTCMonth()]
    return `${EEEE}, ${MMM} ${dd}`
  } catch (err) {
    console.log(err)
    return ''
  }
}

export const dateFormatterUTC = (date, trim = false) => {
  try {
    const dateRange = date.split(' - ')
    const dateInstance = new Date(dateRange[0])
    let EEEE = days[dateInstance?.getUTCDay()] || ''
    if (trim) EEEE = EEEE?.substring(0, 3) || ''
    const dd = dateInstance?.getUTCDate() || ''
    const MMM = months[dateInstance?.getUTCMonth()] || ''

    if (dateRange.length > 1) {
      const dateInstance2 = new Date(dateRange[1])
      let EEEE2 = days[dateInstance2?.getUTCDay()] || ''
      if (trim) EEEE2 = EEEE2?.substring(0, 3) || ''
      const dd2 = dateInstance2?.getUTCDate() || ''
      const MMM2 = months[dateInstance2?.getUTCMonth()] || ''

      return `${EEEE}, ${MMM} ${dd} - ${EEEE2}, ${MMM2} ${dd2}`
    }

    return `${EEEE}, ${MMM} ${dd}`
  } catch (err) {
    console.log(err)
    return ''
  }
}

export const timeFormatterLocal = datetime => {
  if (datetime instanceof Date) {
    const dateHours = datetime.getHours()
    const amOrPm = dateHours >= 12 ? 'PM' : 'AM'
    const hours = dateHours === 12 ? 12 : dateHours % 12
    const minutes = `${datetime.getMinutes()}`.padStart(2, '0')

    return `${hours}:${minutes} ${amOrPm}`
  }
  return ''
}

export const formatDeliveryDate = (deliveryDate, trim = false, cutoffTime = '00:00:00') => {
  const deliveryCutoff = `${deliveryDate?.split('T')[0]}T${cutoffTime}${getETOffset()}`
  const date = new Date(deliveryCutoff)

  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(today.getDate() + 1)

  const shortDate = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  if (isSameDay(date, today)) return cutoffTime && isPastCutoff(deliveryDate, cutoffTime) ? `Tomorrow, ${shortDate}` : `Today, ${shortDate}`
  if (isSameDay(date, tomorrow)) {
    if (cutoffTime && isPastCutoff(deliveryDate, cutoffTime)) {
      let day = days[date.getDay()]
      if (trim) day = day.substring(0, 3)
      return `${day}, ${months[date.getMonth()]} ${date.getDate()}`
    }
    return `Tomorrow, ${shortDate}`
  }

  let day = days[date.getDay()]
  if (trim) day = day?.substring(0, 3)
  const dd = date.getDate()
  const MMM = months[date.getMonth()]
  return `${day}, ${MMM} ${dd}`
}

export const formatCutoffTimeAsAmPm = cutoffTime => {
  if (!cutoffTime) return null
  const [hours, minutes] = cutoffTime.split(':').map(Number)

  // Convert EST cutoff time to user's local timezone
  const now = new Date()
  const nowET = new Date(
    now.toLocaleString('en-US', { timeZone: ET_TIMEZONE }),
  )
  const cutoffET = new Date(nowET)
  cutoffET.setHours(hours, minutes, 0, 0)
  const estToLocalOffset = Number(now) - Number(nowET)
  const cutoffLocal = new Date(Number(cutoffET) + estToLocalOffset)

  const h = cutoffLocal.getHours()
  const m = cutoffLocal.getMinutes()
  const suffix = h >= 12 ? 'pm' : 'am'
  const displayHour = h % 12 || 12
  if (m > 0) {
    return `${displayHour}:${String(m).padStart(2, '0')}${suffix}`
  }
  return `${displayHour}${suffix}`
}

export const formatDeliveryType = (deliveryDate, cutoffTime = '00:00:00') => {
  const deliveryCutoff = `${deliveryDate?.split('T')[0]}T${cutoffTime}${getETOffset()}`
  const date = new Date(deliveryCutoff)

  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(today.getDate() + 1)

  if (isSameDay(date, today)) return cutoffTime && isPastCutoff(deliveryDate, cutoffTime) ? 'NextDay' : 'SameDay'
  if (isSameDay(date, tomorrow)) return cutoffTime && isPastCutoff(deliveryDate, cutoffTime) ? 'NextBusinessDay' : 'NextDay'
  return 'NextBusinessDay'
}

export const getShippingLabelText =
  ({
    unfoldedShippingCookie,
    unfoldedShipping,
    isDeliveryLastMile,
    hasUnfoldedOptions,
    method,
    methodName,
    displayDefaultLabel = false,
  }) => {
    const methodVariant = isDeliveryLastMile && method?.cutoffTime && !displayDefaultLabel
      ? formatDeliveryType(method?.deliveryDate || method?.date, method?.cutoffTime).toLowerCase() : methodName?.toLowerCase()

    const findVariation = hasUnfoldedOptions
      ? unfoldedShipping?.label?.variations?.find(v => v.variationValue === unfoldedShippingCookie)
      : undefined
    switch (methodVariant) {
      case 'sameday': return 'Same-Day Delivery'
      case 'nextday': return 'Next-Day Delivery'
      case 'nextbusinessday': return 'Next Business Day Delivery'
      case 'ground': return findVariation?.foldedLabel || 'Standard'
      case 'ground_unfolded': return findVariation?.unfoldedLabel || 'Truck Freight'
      default: return method.label
    }
  }
